import React from 'react';

import SadFaceSvg from 'App/assets/img/sad-face.svg?url';

import { ModalContainer } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';

import {
	Container,
	Content,
	IconContainer,
	Title,
	CampaignContainer,
	CampaignImage,
	CampaignTitle,
	CampaignText,
	CenterText,
	ButtonContainer,
} from './ModalNotAuthorized.styles';
import { useModalNotAuthorized } from './ModalNotAuthorized.hooks';

type ModalNotAuthorizedProps = {
	imageUrl: any;
	title: string;
	message: string;
	onClose: () => void;
};

export const ModalNotAuthorized = ({
	imageUrl,
	title,
	message,
	onClose,
}: ModalNotAuthorizedProps): JSX.Element => {
	const { handleLinkToWhatsapp } = useModalNotAuthorized(title);

	const createHeightModalResponsive = (): string => {
		if (window.matchMedia('(max-height: 1400px)').matches) return '450px';
		if (window.matchMedia('(max-height: 900px)').matches) return '630px';

		return '';
	};

	return (
		<ModalContainer
			visible
			height={createHeightModalResponsive()}
			zIndex={1200}
			closeOnlyOnTheButton
			onClose={onClose}
			padding={'0px'}
		>
			<Container>
				<Content>
					<IconContainer>
						<img src={SadFaceSvg} alt="Modal Confirm" />
					</IconContainer>
					<Title>Tu plan actual no incluye este beneficio</Title>

					<CampaignContainer>
						<CampaignImage src={imageUrl}></CampaignImage>
						<div>
							<CampaignTitle>{title}</CampaignTitle>
							<CampaignText>{message}</CampaignText>
						</div>
					</CampaignContainer>

					<CenterText>Mejora tu plan para acceder a este beneficio</CenterText>
					<ButtonContainer>
						<Button key={'1'} onClick={handleLinkToWhatsapp} width="240px">
							Más información
						</Button>
					</ButtonContainer>
					<Button variant="ghost" onClick={onClose} width="240px">
						En otro momento
					</Button>
				</Content>
			</Container>
		</ModalContainer>
	);
};
